import React, { useEffect, useState } from 'react';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrIframeUrl, setRoutes } from 'store/action';
import Login from 'pages/login';
import NotFound from 'pages/notFound';
import Layout from 'components/layout';
import WaterMark from 'utils/watermark';
import { TyRoute } from 'typings/tyRoute';
import TestFloors from '../pages/testFloors';
import allRoutesFunc from './allRoutes';
import { iteratorTree } from '../utils';

// 将层级配置路由数据平铺，并设置，这里不做路由嵌套。
const treeRoute = (routes: TyRoute, doms: JSX.Element[]) => {
  if (routes.target !== '_blank' && routes.url) {
    doms.push(
      <Route
        path={routes.url}
        key={routes.key}
        component={
          () => {
            if (routes.component) {
              return <Layout pageComponent={routes.component} />;
            }
            return <></>;
          }
        }
      />,
    );
  }
  if (routes.children && routes.children.length > 0) {
    routes.children.forEach((item: TyRoute) => {
      treeRoute(item, doms);
    });
  }
};

const waterMark = new WaterMark();
export const AppRouter = () => {
  const dispatch = useDispatch();
  // 其他组件的钩子
  const routes = useSelector<any, any>((state) => state.routes);
  const comRefs = useSelector<any, any>((state) => state.comRefs);
  const [routeDoms, setRouteDoms] = useState<JSX.Element[]>([]);
  const [defaultRoute, setDefaultRoute] = useState<TyRoute | null>(null);
  const initRoutes = (allRoutes: TyRoute[]) => {
    if (allRoutes.length > 0) {
      const newRouteDoms: JSX.Element[] = [];
      allRoutes.forEach((item: TyRoute) => {
        treeRoute(item, newRouteDoms);
      });
      setRouteDoms(newRouteDoms);
      let tmpDefaultRoute: TyRoute | undefined;
      if (allRoutes[0].url) {
        [tmpDefaultRoute] = allRoutes;
      } else {
        iteratorTree(allRoutes[0], allRoutes, (node: TyRoute) => {
          if (node.url) {
            tmpDefaultRoute = node;
            return true;
          }
          return false;
        });
      }
      if (tmpDefaultRoute) {
        setDefaultRoute(tmpDefaultRoute);
      }
      if (tmpDefaultRoute && tmpDefaultRoute.menuUrl) {
        dispatch(setCurrIframeUrl(tmpDefaultRoute.menuUrl));
      }
    }
  };
  useEffect(() => {
    if (window.location.pathname !== '/login' && !routes.length) {
      if (routes.length > 0) {
        initRoutes(routes);
      } else {
        allRoutesFunc().then((allRoutes: TyRoute[]) => {
          dispatch(setRoutes(allRoutes));
          initRoutes(allRoutes);
        });
      }
    }
  }, []);
  
  const isBaseUrlHealth = window.location?.pathname?.split('/')?.[1] == 'health';

  return (
    <BrowserRouter basename={isBaseUrlHealth ? "/health" : "/"}>
      <Switch>
        <Route path="/login" key="/login">
          <Login />
        </Route>
        {routeDoms.map((item: JSX.Element) => item)}
        {
          defaultRoute && defaultRoute.url ? <Redirect exact from="/" to={defaultRoute.url} /> : <></>
        }
        <Route path="*" key="*****">
          <NotFound />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};
